import { AxiosInstance } from "axios";
import { IUser } from "types/user";

class UserApi {
	http: AxiosInstance;
	constructor(axiosInstance: AxiosInstance) {
		this.http = axiosInstance;
	}

	get = () => this.http.get<IUser[]>("user").then((res) => res.data);
}

export default UserApi;
